import { SET_CUSTOM_FIELD_7 } from 'actions';

export function setCustomField7(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_7 };
}
